module.exports = __webpack_public_path__ + "img/4-8-3.6f5ee422.png";